import React from 'react';
import style from './block.module.scss';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

function SinglePostFooter({ permalink, date }) {
    return (
        <div className={style.block}>
            <p className={style.date}>Le {date}</p>
            <div className={style.social}>
                <a href={'https://www.facebook.com/sharer/sharer.php?u=' + permalink} target="_blank" rel="noreferrer">
                    <FacebookIcon />
                </a>
                <a
                    class="twitter-share-button"
                    href={'https://www.twitter.com/share?url=' + permalink}
                    target="_blank"
                    rel="noreferrer"
                >
                    <TwitterIcon />
                </a>
                <a
                    href={'https://www.linkedin.com/sharing/share-offsite/?url=' + permalink}
                    target="_blank"
                    rel="noreferrer"
                >
                    <LinkedInIcon />
                </a>
            </div>
        </div>
    );
}

export default SinglePostFooter;
